/* eslint-disable react/display-name */
import React from "react";

const Toolbar = React.forwardRef(({ children, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    css={{
      width: "100%",
      padding: "0rem 1rem 0.5rem 1rem",
      borderBottom: "2px solid #eee",
      marginBottom: "0.5rem",
      display: "flex",
      flexDirection: "column",
    }}
  >
    {children}
  </div>
));

export default Toolbar;
